// Copyright (c) 2017 Deere & Company

import claimSummary from './claim-summary';
import {combineReducers} from 'redux';

export const getCombinedReducers = () => combineReducers({
    claimSummary
});




// WEBPACK FOOTER //
// ./src/reimbursement-summary/claims/reducers/index.js